import { render, staticRenderFns } from "./ProductDropDown.vue?vue&type=template&id=19b50ee1&scoped=true"
import script from "./ProductDropDown.vue?vue&type=script&lang=js"
export * from "./ProductDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b50ee1",
  null
  
)

export default component.exports